module.exports = __webpack_public_path__ + "images/qrCode.86fd7d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/qrCode.png
// module id = 9Htt
// module chunks = 19